import { render } from "./domainData.vue?vue&type=template&id=056c0312"
import script from "./domainData.vue?vue&type=script&lang=js"
export * from "./domainData.vue?vue&type=script&lang=js"

import "./domainData.vue?vue&type=style&index=0&id=056c0312&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__